import { call, put } from "redux-saga/effects";
import {
  GET_ADVERTISER_FAILED,
  GET_ADVERTISER_SUCCESS,
  GET_S3FILESANDFOLDERS_FAILED,
  GET_S3FILESANDFOLDERS_SUCCESS,
  UPLOAD_FILES_FAILED,
  UPLOAD_FILES_SUCCESS,
  UPLOAD_TO_DSP_FAILED,
  UPLOAD_TO_DSP_SUCCESS,
  VALIDATE_FOLDER_NAME_FAILED,
  VALIDATE_FOLDER_NAME_SUCCESS,
  GET_S3FILESANDFOLDERS_REQUEST,
} from "../Actions/OPCreativeUploadActions";
import { TOAST_SHOW } from "../Actions/ToastAction";
import axios from "../../axiosConfig";

export function* GetAdvSaga(): unknown {
  try {
    const response = yield call(axios.get, "getAdvertisersList");
    const { data, status } = response;
    if (status === 200) {
      yield put({ type: GET_ADVERTISER_SUCCESS, payload: data.advertisers });
    }
  } catch (error: any) {
    if (error.response.status === 500) {
      if (error.response.data.message) {
        yield put({
          type: TOAST_SHOW,
          payload: {
            message: error.response.data.message,
            severity: "Danger",
            show: true,
          },
        });
      }
    } else {
      yield put({
        type: TOAST_SHOW,
        payload: {
          message: "Something Went wrong please try again",
          severity: "Danger",
          show: true,
        },
      });
    }

    yield put({ type: GET_ADVERTISER_FAILED, payload: false });
  }
}
export function* GetS3FoldersAndFilesSaga(action:any): unknown {
  try {
    const response = yield call(axios.get, `getS3List?root=${action.payload}`);
    const { data, status } = response;
    if (status === 200) {
      yield put({ type: GET_S3FILESANDFOLDERS_SUCCESS, payload: data });
    }
  } catch (error: any) {
    if (error.response.status === 500) {
      if (error.response.data.message) {
        yield put({
          type: TOAST_SHOW,
          payload: {
            message: error.response.data.message,
            severity: "Danger",
            show: true,
          },
        });
      }
    } else {
      yield put({
        type: TOAST_SHOW,
        payload: {
          message: "Something Went wrong please try again",
          severity: "Danger",
          show: true,
        },
      });
    }

    yield put({ type: GET_S3FILESANDFOLDERS_FAILED, payload: false });
  }
}

export function* validateFolderNameSaga (action:any):unknown{
  try {
    const response = yield call(axios.get, `validateName?folderName=${action.payload}`);
    const { 
      //data, 
      status 
    } = response;
    if (status === 200) {
      yield put({ type: VALIDATE_FOLDER_NAME_SUCCESS, payload: true });
    }
  } catch (error:any) {
    if (error.response.status === 500) {
      if (error.response.data.message) {
        yield put({ type: VALIDATE_FOLDER_NAME_FAILED});
      
      }
    } else {
      yield put({
        type: TOAST_SHOW,
        payload: {
          message: "Something Went wrong please try again",
          severity: "Danger",
          show: true,
        },
      });
    }

    yield put({ type: VALIDATE_FOLDER_NAME_FAILED });
  }
}


export function* uploadToS3Saga(action: any): unknown {
  try {
    const response = yield call(axios.post, `uploadToS3`, action.payload.data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    const { 
      //data, 
      status 
    } = response;
    if (status === 200) {
      yield put({ type: UPLOAD_FILES_SUCCESS, payload: true });
      if(action.payload.folder  !== "undefined"){ 
        yield put({type:GET_S3FILESANDFOLDERS_REQUEST,payload:action.payload.folder});
      }
    }
  } catch (error: any) {
    if (error.response.status === 500) {
      if (error.response.data.message) {
        yield put({ type: UPLOAD_FILES_FAILED, payload: false });
      }
    } else {
      yield put({
        type: TOAST_SHOW,
        payload: {
          message: "Something Went wrong please try again",
          severity: "Danger",
          show: true,
        },
      });
    }

    yield put({ type: UPLOAD_FILES_FAILED });
  }
}


export function* uploadToDSPSaga (action:any):unknown{
  try {
    const response = yield call(axios.post, `uploadToDSP`,action.payload);
    const { 
      //data, 
      status 
    } = response;
    if (status === 200) {
      yield put({ type: UPLOAD_TO_DSP_SUCCESS, payload: true });
    }
  } catch (error:any) {
    if (error.response.status === 500) {
      if (error.response.data.message) {
        yield put({ type: UPLOAD_TO_DSP_FAILED, payload: false });
      
      }
    } else {
      yield put({
        type: TOAST_SHOW,
        payload: {
          message: "Something Went wrong please try again",
          severity: "Danger",
          show: true,
        },
      });
    }

    yield put({ type: UPLOAD_TO_DSP_FAILED });
  }
}
